<template>
  <div class="cartsave-list-items">
    <TransitionGroup name="cartsave-list" tag="div">
      <div :class="{'inactiveCartSaveItem':item.data.filter.isSalableAndActive !== true}" class="cart-item bg-white white-bg p-3 align-items-center col-12 border-bottom" v-for="(item) in cart.items" :key="item.id">
        <div class="row">
          <div class="col-lg-6">
        <div class="row align-items-top">
        <div class="col-lg-4">
          <div class="bg-white-shadow">
            <img v-if="item.data.images.variation.length > 0 && item.data.images.variation[0].urlPreview" :src="item.data.images.variation[0].urlPreview" class="img-fluid">
            <img v-else-if="item.data.images.variation.length > 0 &&  item.data.images.variation[0].urlSecondPreview" :src="item.data.images.variation[0].urlSecondPreview" class="img-fluid">
            <img v-else-if="item.data.images.all[0].urlPreview" class="img-fluid" :src="item.data.images.all[0].urlPreview">
            <img v-else :src="item.data.images.all[0].urlMiddle" class="img-fluid">
          </div>
        </div>
        <div class="col-lg-8" >
          <template v-if="item.data.variation.isActive == true">
            <a class="font-weight-bold" v-html="item.data.texts.name1" :href="item.data | itemURL(urlWithVariationId)"></a>
          </template>
          <template v-else>
            <a class="font-weight-bold" v-html="item.data.texts.name1"></a>
          </template>
          <template v-if="item.data.variation.isActive == true">
            <p class="text-muted small"  v-html="item.data.variation.availability.names.name"></p>
          </template>
          <template v-else>
            <p class="text-muted small" > {{ $translate("CartSave::Template.itemNotAvailable") }}</p>
          </template>
          <ul v-if="item.data.attributes.length > 0" class="list-unstyled list-inline">
            <li v-for="attribut in item.data.attributes">
              <span class="font-weight-bold" v-html="attribut.attribute.names.name"></span>: <span v-html="attribut.value.names.name"></span>
            </li>
          </ul>
        </div>
      </div>
      </div>

          <template v-if="editable || isPublic">
            <!-- quantity -->
            <div class="col-lg-2 col-4 qutantity">
              <div class="qty-box d-flex ml-0">
                <!--
                <input
                    :disabled="item.data.filter.isSalableAndActive !== true"
                    type="text"
                    inputmode="numeric"
                    class="text-center qty-input border-right"
                    @change="updateQuantity(item,cart)"
                    v-model.number="item.quantity"
                />
                -->
                <input
                    :disabled="item.data.filter.isSalableAndActive !== true"
                    type="text"
                    inputmode="decimal"
                    class="text-center qty-input border-right"
                    :value="formatQuantity(item.quantity)"
                    @input="onQuantityInput($event, item, cart)"
                    @change="updateQuantity(item,cart)"
                />
                <div class="cartSaveQuantity">
                  <button :disabled="item.data.filter.isSalableAndActive !== true" class="btn YbbQuantityButtons" @click="updateQuantity(item,cart,'+')">
                    +
                  </button>
                  <button :disabled="item.data.filter.isSalableAndActive !== true"  class="btn YbbQuantityButtons"  @click="updateQuantity(item,cart,'-')">
                    -
                  </button>
                </div>
              </div>
            </div>
          </template>
            <div class="col-lg-2 col-4">
              <div class="flex-column">
                <div>
                  <b>
                    {{ $translate("CartSave::Template.cartItemPrice") }}
                  </b>
                </div>
                <div>
                  {{ item.data.prices.default.price.value * item.quantity | currency }}
                </div>
              </div>
            </div>
            <!-- bearbeiten -->
          <template v-if="editable || isPublic">
            <div class="col-lg-2 col-4">
              <div class="btn-block-bg d-flex justify-content-end">
                <div class="btn-group" role="group" aria-label="Basic example">
                  <button :disabled="item.data.filter.isSalableAndActive !== true || item.cartloading" @click="addToBasket(item)" class="btn btn-primary btn-min-width-small mr-2">
                    <template v-if="item.cartloading">
                      <i class="fa fa-circle-o-notch fa-spin"></i>
                    </template>
                    <template v-else>
                      <i class="fa fa-shopping-cart"></i>
                    </template>
                  </button>
                  <button @click="deleteItem(cart.id,item.id)" class="btn btn-danger btn-min-width-small">
                    <i class="fa fa-times"></i>
                  </button>
                </div>
              </div>
            </div>
          </template>
          <template v-else>
          <!-- menge -->
          <div class="col-lg-2 col-4">
            <div class="flex-column">
              <div>
                <b>
                  {{  $translate("CartSave::Template.cartItemQuantity") }}
                </b>
              </div>
              <div>
                {{ item.quantity }} x
              </div>
            </div>
          </div>
          <!-- preis total -->
          <div class="col-lg-2 col-4">
            <div>
              <b>
                {{  $translate("CartSave::Template.cartItemPriceTotal") }}
              </b>
            </div>
            <div>
              {{ item.quantity * item.data.prices.default.price.value | currency }}
            </div>
          </div>
          </template>
        </div>
      </div>
    </TransitionGroup>
  </div>
</template>

<script>
export default
{
  name: "csListItems",
  props:
  {
    editable:
    {
      type:Boolean,
      default:false
    },
    cart:
    {
      type:Object,
      default: function () { return {} }
    },
    isPublic:
    {
      type:Boolean,
      default:false
    }
  },
  methods:
  {
    formatQuantity(value) {
      return value != null ? value.toString().replace('.', ',') : '';
    },
    onQuantityInput(event, item, cart) {
      let value = event.target.value.replace(',', '.'); // Komma zu Punkt für Rechnen
      item.quantity = parseFloat(value);
    },
    getOverallPrice(items) {
      const total = items.reduce((sum, item) => {
        const price = item.data.prices.default.price.value;
        const quantity = item.quantity;
        return sum + price * quantity;
      }, 0);

      // Währungsformatierung
      return this.formatCurrency(total);
    },
    formatCurrency(amount) {
      const currencySymbol = App.activeCurrency || '€'; // Fallback zu '€', falls keine Währung gesetzt ist

      // Hier wird der Betrag als Währungsstring formatiert
      return `${amount.toFixed(2).replace('.',',')} ${currencySymbol}`;
    },
    deleteItem(cartid,itemid)
    {
      if(!this.isPublic)
      {
        this.$store.dispatch('removeItemFromList', {"cartid": cartid, "itemid": itemid});
      }
      else
      {
        for(let i = 0; i < this.cart.items.length; i++)
        {
          if(parseInt(this.cart.items[i].id) === parseInt(itemid))
          {
            this.cart.items.splice(i,1)
          }
        }
      }
    },
    updateQuantity(item,cart,operator = null)
    {
      console.log(cart);
      if (operator == null)
      {
        if (item.quantity >= item.data.variation.minimumOrderQuantity)
        {
          if(!this.isPublic)
          {
            cart.overAllPrice = this.getOverallPrice(cart.items);
            return this.$store.dispatch('updateCart',cart)
          }
        }
        else
        {
          item.quantity = parseFloat(item.data.variation.minimumOrderQuantity.toFixed(1));
          if(!this.isPublic)
          {
            cart.overAllPrice = this.getOverallPrice(cart.items);
            return this.$store.dispatch('updateCart', cart)
          }
        }
      }
      else
      {
        if (operator === '+')
        {
          item.quantity = parseFloat((item.quantity + item.data.variation.intervalOrderQuantity).toFixed(1))
          cart.overAllPrice = this.getOverallPrice(cart.items);
          if(!this.isPublic)
          {
            return this.$store.dispatch('updateCart', cart)
          }

        }
        else
        {
          let newQuantity = parseFloat((item.quantity - item.data.variation.intervalOrderQuantity).toFixed(1));
          if(newQuantity >= item.data.variation.minimumOrderQuantity)
          {
            item.quantity = newQuantity;
          }
          else
          {
            item.quantity = item.data.variation.minimumOrderQuantity;
          }
          cart.overAllPrice = this.getOverallPrice(cart.items);
          if(!this.isPublic)
          {
            return this.$store.dispatch('updateCart', cart)
          }

        }
      }

    },
    addToBasket(item = {},cart)
    {
      let _self = this;
      let data  = { "items":[] };
      if(Object.keys(item).length > 0)
      {
        console.log('item',item)
        item.cartloading = true;
        console.log('item2',item);
        data.items.push({"variationId":item.id,"quantity":item.quantity,"name":item.data.texts.name1});
      }
      else
      {
        for(let i = 0; i < cart.items.length; i++)
        {
          _self.cart.waiting = true;
          if(cart.deleteBasketFirst)
          {
            data.deleteBasketFirst = true;
          }
          if(_self.cart.items[i].data.filter.isSalableAndActive === true)
          {
            data.items.push({
              "variationId" : _self.cart.items[i].id,
              "quantity"    : _self.cart.items[i].quantity,
              "name"        : _self.cart.items[i].data.texts.name1
            });
          }
        }
      }
      $.ajax({
        type: 'POST',
        url: '/rest/cartsave/basket/addToBasket/',
        data: data,
        success: function (data)
        {
          (Object.keys(item).length == 0) ? _self.cart.waiting = false : item.cartloading = false;
          for( let i = 0; i < data.length; i++)
          {
            _self.cart.deleteBasketFirst = false;
            if(data[i].error)
            {
              if(data[i].error.placeholder && data[i].error.placeholder.stock)
              {
                CeresNotification.error(ceresTranslate("CartSave::Template.notesNichtgenugbestand",
                    {
                      variationName: data[i].error.variationName,
                      stock: data[i].error.placeholder.stock
                    })
                );
              }

            }
            else
            {
              _self.cart.deleteBasketFirst = false;
              CeresNotification.success(ceresTranslate("CartSave::Template.notesArtikelhinzugefuegt")).closeAfter(3000);
            }
            if(i === data.length-1)
            {
              vueApp.$store.commit("setBasketItems", data[i].basketItems);
              vueApp.$store.commit("setBasket", data[i].basket);
            }
          }
        },
        error: function (jqXHR, textStatus, errorThrown)
        {
          _self.cart.deleteBasketFirst = false;
          (Object.keys(item).length == 0) ? _self.cart.waiting = false : item.cartloading = false;
          console.log('error',jqXHR,textStatus,errorThrown)
        }
      });
    },
  },
  computed:
  {
    urlWithVariationId()
    {
      return !this.$ceres.config.item.showPleaseSelect || this.$ceres.initialPleaseSelect == 0 || this.forceUrlWithVariationId;
    }
  }
}
</script>

